import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/inherits";
import * as tslib_1 from "tslib";
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { Getter } from "vuex-class";
import * as types from "@/store/constants/types";
import { getStatusBarHeight } from "@/utils/statusBarHeight";
import Nav from "@/components/nav/navBar.vue";
import GeneralUtilsHelper from '@/utils/generalUtils';
import { isIos } from "@/utils/lodash";

var HeaderVideo =
/*#__PURE__*/
function (_Vue) {
  _inherits(HeaderVideo, _Vue);

  function HeaderVideo() {
    var _this;

    _classCallCheck(this, HeaderVideo);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HeaderVideo).apply(this, arguments));
    _this.videoName = '';
    return _this;
  }

  _createClass(HeaderVideo, [{
    key: "clickClose",
    value: function clickClose() {}
  }, {
    key: "videoPlay",
    value: function videoPlay() {
      var videoEl = document.getElementById("vipVideo");

      if (this.videoName && videoEl) {
        var promise = videoEl.play();

        if (promise !== undefined) {
          promise.catch(function (error) {
            console.log("// Auto-play was prevented");
          }).then(function () {// console.log("Auto-play started");
          });
        }
      }
    }
  }, {
    key: "getVideoUrl",
    value: function () {
      var _getVideoUrl = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var videoType;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                videoType = this.lunchConfig && this.lunchConfig.launch_vip_video_local_resource ? "local" : "online";
                _context.next = 3;
                return GeneralUtilsHelper.getVideoFileUrl(this.videoString + '.mp4', videoType);

              case 3:
                this.videoName = _context.sent;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getVideoUrl() {
        return _getVideoUrl.apply(this, arguments);
      }

      return getVideoUrl;
    }()
  }, {
    key: "created",
    value: function created() {
      this.getVideoUrl();
    }
  }, {
    key: "mounted",
    value: function mounted() {
      if (isIos()) {
        document.addEventListener("resume", this.videoPlay, false);
      }
    }
  }, {
    key: "destroyed",
    value: function destroyed() {
      if (isIos()) {
        document.removeEventListener("resume", this.videoPlay, false);
      }
    }
  }, {
    key: "androidStatusBarHeight",
    get: function get() {
      return getStatusBarHeight();
    }
  }]);

  return HeaderVideo;
}(Vue);

tslib_1.__decorate([Getter(types.GETTER_LAUNCH_CONFIG)], HeaderVideo.prototype, "lunchConfig", void 0);

tslib_1.__decorate([Prop()], HeaderVideo.prototype, "showIcon", void 0);

tslib_1.__decorate([Prop({
  default: 'vip_all'
})], HeaderVideo.prototype, "videoString", void 0);

tslib_1.__decorate([Prop({
  default: 'vip_all_index'
})], HeaderVideo.prototype, "posterName", void 0);

tslib_1.__decorate([Emit('clickClose')], HeaderVideo.prototype, "clickClose", null);

HeaderVideo = tslib_1.__decorate([Component({
  components: {
    Nav: Nav
  }
})], HeaderVideo);
export default HeaderVideo;